var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleCropper)?_c('vue-cropper',_vm._b({ref:"cropper",attrs:{"crossorigin":"","alt":"","crop":_vm.cropImage,"src":_vm.src}},'vue-cropper',_vm.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }